import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomUserDataService } from './data.service';

@NgModule({
  imports: [CommonModule],
  providers: [CustomUserDataService],
})
export class UserModule {}
